import React, { Dispatch, SetStateAction } from "react";
import { IShareMemberInput } from "../../exports/interfaces";
import { TriangleAlert, Upload } from "lucide-react";
import {
  renderExistingFilePreview,
  renderFilePreview,
} from "../../exports/functions";

const ShareMember = ({
  shareMember,
  setShareMember,
}: {
  shareMember: IShareMemberInput;
  setShareMember: Dispatch<SetStateAction<IShareMemberInput>>;
}) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;

    setShareMember((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputFile: string,
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (inputFile === "shareMember") {
        setShareMember((prev) => ({
          ...prev,
          shareMemberFileName: file.name,
          shareMemberFile: file,
          shareMemberDocumentUrl: "",
        }));
      } else if (inputFile === "savingMember") {
        setShareMember((prev) => ({
          ...prev,
          savingMemberFileName: file.name,
          savingMemberFile: file,
          savingMemberDocumentUrl: "",
        }));
      } else {
        setShareMember((prev) => ({
          ...prev,
          loanMemberFileName: file.name,
          loanMemberFile: file,
          loanMemberDocumentUrl: "",
        }));
      }
    }
  };
  return (
    <>
      {/* <div className={`dashboard-card mt-2 share-member-container`}>
        <div className="row g-3">
          <div className="col-12">
            <h6 className="primary-color">
              Upload CSV or Excel files containing cooperative member data.
            </h6>
            <ol>
              <li>
                सबैभन्दा पहिला ३ वटा (निम्नलिखित) टेम्प्लेटहरू (Template)
                डाउनलोड गर्नुहोला ।
              </li>
              <li>
                माथी डाउनलोड गरेको टेम्प्लेटहरू कम्प्युटरमा सेभ गरेर खोल्नुहोस्
                ।
              </li>
              <li>
                यो टेम्प्लेटको Title अर्थात् पहिलो लार्इन (First Row) मा भएको
                विवरण फेरबदल नगर्नुहोला ।
              </li>
              <li>
                रातो कलर गरेको कोलममा खाली नछोड्नुहोला । यदि त्यस्तो भएमा डाटा
                अपलोड हुदैन ।
              </li>
              <li>
                Date को विवरण प्रविष्ट गर्दा YYYY/MM/DD अर्थात् (४ अंकको वर्ष/२
                अंकको महिना/२ अंकको दिन) नै हुनुपर्ने छ ।
              </li>
              <li>
                Excel Sheet मा भएको सबै Column मा उपयुक्त विवरण भर्नुहोला ।
              </li>
            </ol>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2 primary-border`}>
        <p className="primary-color">
          Note: यदि एकपटक अपलोड गरेको कुनै एक वा सबै फाइलको स्टाटसमा अपलोड Fail
          देखाएको खण्डमा तपाइले सोही फाइल पुनः अपलोड नगर्नुहोला । यस्तो अवस्थामा
          फाइलमा गएर नमिलेको कुरा सच्याउने वा View Details मा गएर Failed भएको
          Row को डाटा सच्याएर Refresh Icon मा Click गर्नुहोला। डाटा नसच्याइ सोही
          फाइल पुनः अपलोड नगर्नुहोला।
        </p>
      </div> */}
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Share Members File</h6>
            <small>
              सहकारीका सबै भन्दा ठुला १०० सेयर सदस्यहरूको विवरण भएको EXCEL फाइल
              (Excel file of top 100 cooperative's share members detail) अपलोड
              गर्नुहोला ।
            </small>
          </div>

          <button className="btn px-3 btn-badge">Download Template</button>
        </div>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">
              Male Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="shareMaleMembers"
              value={shareMember.shareMaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Female Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="shareFemaleMembers"
              value={shareMember.shareFemaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Others Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="shareOthersMembers"
              value={shareMember.shareOthersMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Total Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="shareTotalMembers"
              value={shareMember.shareTotalMembers || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row g-3 mt-2">
          <div className="col-12">
            <label className="form-label">Upload Document (CSV / xlsx)</label>
            <div
              className={`upload-box p-4 ${!shareMember.shareMemberFile && !shareMember.shareMemberDocumentUrl && "text-center"}`}
            >
              {shareMember.shareMemberFile ? (
                renderFilePreview(
                  shareMember.shareMemberFile,
                  shareMember.shareMemberFileName,
                  (e: any) => handleFileChange(e, "shareMember"),
                )
              ) : shareMember.shareMemberDocumentUrl ? (
                renderExistingFilePreview(
                  shareMember.shareMemberDocumentUrl,
                  (e: any) => handleFileChange(e, "shareMember"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "shareMember");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Saving Members File</h6>
            <small>
              सहकारीमा सबैभन्दा धेरै रकम बचत गर्ने १०० सदस्यहरूको विवरण भएको
              EXCEL फाइल (Excel file of top 100 cooperatives saving member)
              अपलोड गर्नुहोला ।
            </small>
          </div>

          <button className="btn px-3 btn-badge">Download Template</button>
        </div>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">
              Male Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="savingMaleMembers"
              value={shareMember.savingMaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Female Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="savingFemaleMembers"
              value={shareMember.savingFemaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Others Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="savingOthersMembers"
              value={shareMember.savingOthersMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Total Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="savingTotalMembers"
              value={shareMember.savingTotalMembers || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row g-3 mt-2">
          <div className="col-12">
            <label className="form-label">Upload Document (xlsx)</label>

            <div
              className={`upload-box p-4 ${!shareMember.savingMemberFile && !shareMember.savingMemberDocumentUrl && "text-center"}`}
            >
              {shareMember.savingMemberFile ? (
                renderFilePreview(
                  shareMember.savingMemberFile,
                  shareMember.savingMemberFileName,
                  (e: any) => handleFileChange(e, "savingMember"),
                )
              ) : shareMember.savingMemberDocumentUrl ? (
                renderExistingFilePreview(
                  shareMember.savingMemberDocumentUrl,
                  (e: any) => handleFileChange(e, "savingMember"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "savingMember");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2`}>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div>
            <h6>Loan Members File</h6>
            <small>
              सहकारीबाट धेरै रकम ऋण लिने मध्यका १०० सदस्यहरूको विवरण भएको EXCEL
              फाइल (Excel file of top 100 cooperative's loan members detail)
              अपलोड गर्नुहोला ।
            </small>
          </div>

          <button className="btn px-3 btn-badge">Download Template</button>
        </div>
        <div className="row g-3">
          <div className="col-md-3">
            <label className="form-label">
              Male Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="loanMaleMembers"
              value={shareMember.loanMaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Female Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="loanFemaleMembers"
              value={shareMember.loanFemaleMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Others Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="loanOthersMembers"
              value={shareMember.loanOthersMembers || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">
              Total Members <span className="primary-color">*</span>
            </label>
            <input
              type="number"
              className="form-control with-spin"
              placeholder="0"
              name="loanTotalMembers"
              value={shareMember.loanTotalMembers || ""}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="row g-3 mt-2">
          <div className="col-12">
            <label className="form-label">Upload Document (CSV / xlsx)</label>

            <div
              className={`upload-box p-4 ${!shareMember.loanMemberFile && !shareMember.loanMemberDocumentUrl && "text-center"}`}
            >
              {shareMember.loanMemberFile ? (
                renderFilePreview(
                  shareMember.loanMemberFile,
                  shareMember.loanMemberFileName,
                  (e: any) => handleFileChange(e, "loanMember"),
                )
              ) : shareMember.loanMemberDocumentUrl ? (
                renderExistingFilePreview(
                  shareMember.loanMemberDocumentUrl,
                  (e: any) => handleFileChange(e, "loanMember"),
                )
              ) : (
                <>
                  <Upload />

                  <p className="mb-1">
                    Choose a file or drag and drop it here.
                  </p>

                  <small className="d-block mb-3">
                    (txt, docx, xlsx, pdf, jpeg, png - Up to 100 mb)
                  </small>

                  <label className="btn btn-badge text-main-color">
                    Browse file
                    <input
                      hidden
                      type="file"
                      onChange={(e) => {
                        handleFileChange(e, "loanMember");
                      }}
                    />
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`dashboard-card mt-2 primary-border`}>
        <p className="primary-color">
          Note: तपाईंले अपलोड गर्न खोज्नुभएको फाइल सफलतापूर्वक अपलोड भए पश्चात
          प्रत्यक फाइलको Status कोलममा COMPLETED देखिएपछि मात्र Next Step मा जान
          अनुमति मिल्नेछ ।
        </p>
      </div>
      <div className={`dashboard-card mt-2 primary-border`}>
        <p className="primary-color d-flex align-items-center gap-2">
          <i>
            <TriangleAlert />
          </i>
          All member files must be uploaded and processed to proceed
        </p>
      </div>
    </>
  );
};

export default ShareMember;
